import { Component, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NeproseService } from '../services/neprose.service';
import { environment } from 'src/environments/environment';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.css']
})
export class SearchResultComponent implements OnInit, AfterViewInit {

  listedFor: string

  type: string

  propertyType: string

  propertyTypes = []

  location: string

  properties = []

  provinceList = []

  districtList = []

  municipalityList = []

  loading: boolean = true

  closeMunicipality: number 

  highestMunicipalitySimilarity: number = 0

  closeDistrict: number

  highestDistrictSimilarity: number = 0

  closeProvince: number

  highestProvinceSimilarity: number = 0

  keywordValue: number

  keywordTitle: string

  correctedLocation: string

  searchForm: FormGroup

  selectedOption: string = 'date'

  selectedFilterOption: string = 'new'

  availableFilterOptions = [
    {value: 'new', viewValue: 'New'},
    {value: 'old', viewValue: 'Old'},
  ]

  seoData: SeoSocialShareData = {
    title:  'Search Result',
    description: 'Search Properties near you.',
    image: environment.url+'/assets/logo.png'
  };

  constructor( private route: ActivatedRoute, private changeDetector: ChangeDetectorRef, private neproseService: NeproseService,
    private router: Router, private seo: SeoSocialShareService ) { }

  ngOnInit(): void {
    this.seo.setData(this.seoData)
    this.route.data.subscribe((data: {propertyType: any, provinceList: any, districtList: any, municipalityList: any})=> {
      this.propertyTypes = data.propertyType
      this.provinceList = data.provinceList.provinces
      this.districtList = data.districtList.districts
      this.municipalityList = data.municipalityList.municipalities
    })
    this.listedFor = this.route.snapshot.params.listingFor
    this.type = this.route.snapshot.params.type
    this.location = this.route.snapshot.params.keyword
    this.searchForm = new FormGroup({
      type: new FormControl(null, [Validators.required]),
      keyword: new FormControl(''),
      listingFor: new FormControl(null, [Validators.required]) 
    })
  }

  searchLocation(){
    let testLocation = this.location
    for(let district of this.districtList){
      let currentLocation = district.district
      let similarity = this.similarity(testLocation, currentLocation)
      if(similarity > 0.5 && similarity > this.highestDistrictSimilarity){
        this.closeDistrict = district.id
        this.highestDistrictSimilarity = similarity
      }
    }
    for(let municipality of this.municipalityList){
      let currentLocation = municipality.municipality
      let municiplaityName = currentLocation.split(" ")
      testLocation = testLocation.split(" ")[0]
      let similarity = this.similarity(testLocation, municiplaityName[0])
      if(similarity > 0.5 && similarity > this.highestMunicipalitySimilarity){
        this.closeMunicipality = municipality.id
        this.highestMunicipalitySimilarity = similarity
      }
    }
    for(let province of this.provinceList){
      let currentLocation = province.province
      let similarity = this.similarity(testLocation, currentLocation)
      if(similarity > 0.5 && similarity > this.highestProvinceSimilarity){
        this.closeProvince = province.id
        this.highestProvinceSimilarity = similarity
      }
    }
    let highestSimilarity = Math.max(this.highestDistrictSimilarity, this.highestMunicipalitySimilarity, this.highestProvinceSimilarity)
    if(highestSimilarity > 0){
      if(highestSimilarity == this.highestDistrictSimilarity){
        this.keywordTitle = 'districtId'
        this.keywordValue = this.closeDistrict
        this.location = this.districtList.find(district => district.id == this.closeDistrict).district
      }else if(highestSimilarity == this.highestMunicipalitySimilarity){
        this.keywordTitle = 'municipalityId'
        this.keywordValue = this.closeMunicipality
        this.location = this.municipalityList.find(municipality => municipality.id == this.closeMunicipality).municipality
      }else if(highestSimilarity == this.highestProvinceSimilarity){
        this.keywordTitle = 'provinceId'
        this.keywordValue = this.closeProvince
        this.location = this.provinceList.find(province => province.id == this.closeProvince).province
      }
    }
  }

  ngAfterViewInit(){
    let propertyType = this.propertyTypes.find(property => property.id == this.type)
    if(propertyType){
      this.propertyType = propertyType.type
    }
    if(this.location){
      this.searchLocation()
    }
    this.searchForProperty()
    this.changeDetector.detectChanges()
  }

  searchForProperty(){
    this.loading = true
    let selectedPrice = null
    let selectedDate = null
    this.properties = []
    if(this.selectedOption == 'cost'){
      selectedPrice = this.selectedFilterOption
    }else if(this.selectedOption == 'date'){
      selectedDate = this.selectedFilterOption
    }
    this.neproseService.searchProperty(selectedPrice, selectedDate, this.keywordTitle, this.keywordValue, this.type, this.listedFor).subscribe(data => {
      this.loading = false
      if(data.propertiesAd){
        let properties = data.propertiesAd
        if(properties.length > 0){
          for(let property of properties){
            if(property.status == 'completed'){
              property['featuredImage'] = 'assets/placeholder-image.png'
              if(property.PropertyImage){
                let propertyImages = JSON.parse(property.PropertyImage.imagePath)
                if(propertyImages.length > 0){
                  property.featuredImage = environment.api+'/images/'+propertyImages[0]
                }
              }
              let municipality = this.municipalityList.find(municipality => municipality.id == property.municipality_id)
              let address = municipality.municipality
              if(property.village){
                address = property.village+', '+address
              }
              property['address'] = address
              this.properties.push(property)
            }
          }
        }
      }
    }, error => {
      if(error.error.msg){
        this.loading = false
      }
    })
  }


  changeFilterValues(){
    if(this.selectedOption == 'cost'){
      this.availableFilterOptions = [
        {value: 'low', viewValue: 'Low'},
        {value: 'high', viewValue: 'High'},
      ]
      this.selectedFilterOption = 'low'
      this.searchForProperty()
    }else if(this.selectedOption == 'date'){
      this.availableFilterOptions = [
        {value: 'new', viewValue: 'New'},
        {value: 'old', viewValue: 'Old'},
      ]
      this.selectedFilterOption = 'new'
      this.searchForProperty()
    }
  }

  viewProperty(id){
    this.router.navigate(['/property/'+id])
  }

  similarity(s1, s2) {
    var longer = s1;
    var shorter = s2;
    if (s1.length < s2.length) {
      longer = s2;
      shorter = s1;
    }
    var longerLength = longer.length;
    if (longerLength == 0) {
      return 1.0;
    }
    return (longerLength - this.editDistance(longer, shorter)) / parseFloat(longerLength);
  }

  editDistance(s1, s2) {
    s1 = s1.toLowerCase();
    s2 = s2.toLowerCase();
  
    var costs = new Array();
    for (var i = 0; i <= s1.length; i++) {
      var lastValue = i;
      for (var j = 0; j <= s2.length; j++) {
        if (i == 0)
          costs[j] = j;
        else {
          if (j > 0) {
            var newValue = costs[j - 1];
            if (s1.charAt(i - 1) != s2.charAt(j - 1))
              newValue = Math.min(Math.min(newValue, lastValue),
                costs[j]) + 1;
            costs[j - 1] = lastValue;
            lastValue = newValue;
          }
        }
      }
      if (i > 0)
        costs[s2.length] = lastValue;
    }
    return costs[s2.length];
  }

  search(){
    if(this.searchForm.valid){
      this.listedFor = this.searchForm.value.listingFor
      this.type = this.searchForm.value.type
      this.location = this.searchForm.value.keyword
      if(this.location){
        this.searchLocation()
        this.router.navigate(['/search-result/'+this.searchForm.value.type+'/'+this.searchForm.value.listingFor+'/'+this.searchForm.value.keyword])
      }else{
        this.router.navigate(['/search-result/'+this.searchForm.value.type+'/'+this.searchForm.value.listingFor])
      }
      this.searchForProperty()
    }
  }

}
